import { FileArchive, Folder, File } from "lucide-react";

interface ZipInfoCardProps {
  fileName: string;
  folderCount: number;
  fileCount: number;
  fileSize: number;
}

function formatFileSize(bytes: number): string {
  if (bytes === 0) return "0 B";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
}

export function ZipInfoCard({
  fileName,
  folderCount,
  fileCount,
  fileSize,
}: ZipInfoCardProps) {
  return (
    <div className="flex items-center gap-4 p-4 bg-stone-50 rounded-lg border border-stone-200">
      <div className="flex-shrink-0">
        <FileArchive className="h-10 w-10 text-stone-500" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-medium text-stone-900 truncate">{fileName}</p>
        <p className="text-sm text-stone-500">{formatFileSize(fileSize)}</p>
      </div>
      <div className="flex items-center gap-6 text-sm text-stone-600">
        <div className="flex items-center gap-1.5">
          <Folder className="h-4 w-4" />
          <span>
            {folderCount} folder{folderCount !== 1 ? "s" : ""}
          </span>
        </div>
        <div className="flex items-center gap-1.5">
          <File className="h-4 w-4" />
          <span>
            {fileCount} file{fileCount !== 1 ? "s" : ""}
          </span>
        </div>
      </div>
    </div>
  );
}
